import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import partnersImage from '../assets/images/partners.png';

interface StatsSectionProps {
  licensesSold: string;
  clients: number;
  yearsInMarket: number;
  countries: number;
}

// TODO: do it dynamic
const StatsSection: React.FC<StatsSectionProps> = ({
  licensesSold = "11.600",
  clients = 2000,
  yearsInMarket = 26,
  countries = 7,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 4,
        p: 4,
        // maxWidth: 1200,
        mx: 'auto',
        backgroundColor: '#E0F7FB'
      }}
    >
      <Box sx={{ flex: 1, maxWidth: 600 }}>
        <Typography
          variant="overline"
          sx={{
            color: theme.palette.warning.main,
            fontSize: '1rem',
            fontWeight: 'bold',
            letterSpacing: 1,
            mb: 1,
            display: 'block'
          }}
        >
          TRAYECTORIA
        </Typography>
        
        <Typography
          variant="h2"
          sx={{
            fontWeight: 'bold',
            mb: 3,
            color: theme.palette.primary.main
          }}
        >
          {licensesSold}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            lineHeight: 1.6,
            color: theme.palette.text.secondary
          }}
        >
          Licencias vendidas a nivel nacional e internacional. {clients.toLocaleString()} clientes, 
          {yearsInMarket} años en el mercado, presencia en {countries} países
        </Typography>
      </Box>
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Box
          component="img"
          src={partnersImage}
          alt="Empresas asociadas"
          sx={{
            maxWidth: '100%',
            height: 'auto',
            borderRadius: 2,
            // boxShadow: 3
          }}
        />
      </Box>
    </Box>
  );
};

export default StatsSection;